import Dropdown from 'react-bootstrap/esm/Dropdown';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ArrowRight } from '../../../../../assets/icons/chevron-right.svg';
import { CustomButton } from '../CustomButton';

type OrthContextSubMenuProps = {
  children: SubMenuOptions[];
  labelKey: string;
  id?: string;
};

type SubMenuOptions = {
  labelKey: string;
  action?: () => void;
  disabled?: boolean;
};

export function OrthContextSubMenu({ children, labelKey, id }: OrthContextSubMenuProps) {
  const [t] = useTranslation();

  return (
    <Dropdown className="orth-context-menu--submenu" key={id} drop="end">
      <Dropdown.Toggle as={CustomButton} className="orth-context-menu">
        {t(labelKey)}
        <ArrowRight />
      </Dropdown.Toggle>
      <Dropdown.Menu className="orth-context-menu">
        {children?.map((option, index) => {
          const id = `orth-context-menu__item-children-${index}`;
          return (
            <Dropdown.Item key={id} className="orth-context-menu" onClick={option?.action} disabled={option.disabled}>
              {t(option.labelKey)}
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
}
